import { buildVisitLimitReachedPayload, fetchWebsiteEvents } from '@va/dashboard/api-client/website-events.api';
import { getGlobalFilter } from '@va/dashboard/selectors/ui';
import { activeWebsiteSlice } from '@va/dashboard/slices';
import { getWebsites } from '@va/standalone/shared/api-client';
import { UserRole } from '@va/types/website';
import dayjs from 'dayjs';
import { Moment } from 'moment';
import { call, put, select } from 'redux-saga/effects';

export function* fetchAndPopulateExtraWebsiteInfoSaga(args: { websiteId: string; userId: string }) {
  try {
    // Extract more info from the request as necessary
    const response: { websites: { id: string; types: UserRole[]; unlimitedPlanActive?: boolean }[] } = yield call(
      getWebsites,
      { websiteId: args.websiteId, withSubscription: true, withSharedWebsites: true, length: 1000 },
      args.userId,
    );
    const foundWebsite = response?.websites.find((website) => {
      return website.id === args.websiteId;
    });

    if (!foundWebsite) {
      console.error('fetchAndPopulateExtraWebsiteInfoSaga: website not found');
      return;
    }

    const ROLE_PRIORITY: Record<UserRole, number> = {
      [UserRole.OWNER]: 0,
      [UserRole.EDITOR]: 1,
      [UserRole.WATCHER]: 2,
      [UserRole.DASHBOARD]: 3,
    };

    const role = foundWebsite.types.reduce<UserRole | undefined>(
      (prev, current) => (prev === undefined || ROLE_PRIORITY[current] < ROLE_PRIORITY[prev] ? current : prev),
      undefined,
    );

    yield put(
      activeWebsiteSlice.actions.setExtraInfo({
        role: role as UserRole,
        unlimitedPlanActive: foundWebsite.unlimitedPlanActive,
        visitLimitReachedAt: [],
      }),
    );
  } catch (error) {
    console.error('fetchAndPopulateExtraWebsiteInfoSaga: something went wrong', error);
  }
}

export function* fetchVisitLimitReachedAtSaga(args: { websiteId: string }) {
  try {
    const { from, until }: { from: Moment; until: Moment } = yield select(getGlobalFilter);

    const response: Awaited<ReturnType<typeof fetchWebsiteEvents>> = yield call(
      fetchWebsiteEvents,
      args.websiteId,
      buildVisitLimitReachedPayload({ start: from.toISOString(true), end: until.toISOString(true) }),
    );

    const timestamps = response?.payload.map(({ createdAt }) => dayjs(createdAt).valueOf()) ?? [];
    yield put(activeWebsiteSlice.actions.setVisitLimitReachedAt(timestamps));
  } catch (error) {
    console.error('fetchVisitLimitReachedAtSaga: something went wrong', error);
  }
}
